import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import i18n from "../i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth",
    component: () => import("@/views/Index"),
    children: [
      {
        name: "Login",
        path: "",
        component: () => import("@/views/Account/Login"),
      },
    ],
  },
  {
    path: "/",
    name: "Main",
    component: Home,
    beforeEnter: (to, from, next) => {
      // window.document.title = to.name ? i18n.t(to.name) : "UIMS";
      if (
        localStorage.getItem("token") &&
        localStorage.getItem("token") !== "null" &&
        localStorage.getItem("token") !== null &&
        localStorage.getItem("token") !== undefined &&
        localStorage.getItem("token") !== "undefined" &&
        localStorage.getItem("token").substr(0, 2) === "ey"
      ) {
        next();
      } else {
        next({
          name: "Login",
        });
      }
    },
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: () => import("../views/Dashboard"),
      },
      {
        path: "/users",
        name: "users.users",
        component: () => import("../views/Account/Users.vue"),
      },

      {
        path: "/groups",
        name: "groups.groups",
        component: () => import("../views/Account/Groups.vue"),
      },

      {
        path: "/changePassword",
        name: "users.changePassword",
        component: () => import("../views/Account/ChangePassword.vue"),
      },

      {
        path: "/notauthorize",
        name: "notauthorize",
        component: () => import("../views/NotAuthorized.vue"),
      },

      {
        path: "/products",
        name: "products.products",
        component: () => import("../views/Products/Index.vue"),
      },

      {
        path: "/customers",
        name: "customers.customers",
        component: () => import("../views/Customers/Index.vue"),
      },

      {
        path: "/customersProduct",
        name: "customersProduct.customersProduct",
        component: () => import("../views/CustomersProduct/Index.vue"),
      },

      {
        path: "/activations",
        name: "activations.activations",
        component: () => import("../views/Activations/Index.vue"),
      }, 
      {
        path: "/activationsReport",
        name: "activationsReport",
        component: () => import("../views/Activations/activationsReport.vue"),
      },
    ],
  },

  {
    path: "*",
    component: () => import("@/views/Home"),
    children: [
      {
        name: "404 Error",
        path: "",
        component: () => import("@/views/Error"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((toRoute) => {
  window.document.title = i18n.t(toRoute.name);
});

export default router;
